<template>
  <div>
    <vue-headful
      title="School Parents | Gradelyng"
      description="Description goes here"
    />
    <div class="school-parent-section base-type-layout">
      <!-- PAGE TITLE -->
      <div class="container px-1">
        <div class="row">
          <div class="col-12 dashboard-header-row">
            <!-- PAGE TITLE -->
            <div class="page-title">Parents</div>

            <!-- FILTER AND ADD TEACHER INFO -->
            <div class="d-flex">
              <!-- FILTER ICON -->
              <!--<div class="avatar avatar_md btn-whitish left-avatar pointer">
                <span class="icon icon-two icon-filter-icon"></span>
              </div>-->

              <!-- ADD ICON -->
              <!-- <div class="avatar avatar_md btn-accent right-avatar pointer">
                <span class="icon icon-one icon-plus"></span>
              </div>-->
            </div>
          </div>
        </div>
      </div>

      <!-- PARENT INFO DISPLAY SECTION -->
      <div class="container px-1">
        <!-- PARENT INFO LABEL ROW -->
        <div class="row">
          <div class="col-12">
            <!-- HEADER ROW -->
            <div
              class="table-header d-flex justify-content-start align-items-center nowrap w-100 font-11-5 border_grey_dark text-uppercase"
            >
              <div class="col-one">Parent</div>
              <div class="col-two">Email Address</div>
              <div class="col-three">Phone</div>
              <div class="col-four">Options</div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- PARENT DATA ROW -->
          <div class="col-12">
            <!-- PARENT COMPONENT -->
            <transition name="fade" mode="out-in">
              <component
                :is="in_view"
                :show_empty="show_empty"
                :parents="parent_list"
                :pagination="pagination_data"
                :page_data="page_index"
                @switchPage="loadNewParentList($event)"
              ></component>
            </transition>
            <!-- PARENT COMPONENT -->
          </div>

          <!-- REQUEST INVOICE CARD -->
          <!-- <div class="col-4">
            <RequestInvoiceCard @triggerRequestForm="closeSubscribeForm"></RequestInvoiceCard>
          </div>-->
        </div>
      </div>

      <!-- MODAL COMPONENT -->
      <SubscribeRequestModal
        v-if="subscribe_form"
        @closeTriggered="closeSubscribeForm"
      ></SubscribeRequestModal>
      <!-- MODAL COMPONENT -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ParentContentInfo from "@/components/schoolComps/dashboard/parent/ParentContentInfo";
import ParentDefaultInfo from "@/components/schoolComps/dashboard/parent/ParentDefaultInfo";
import RequestInvoiceCard from "@/components/schoolComps/dashboard/parent/RequestInvoiceCard";

export default {
  name: "Parent",

  components: {
    ParentContentInfo,
    ParentDefaultInfo,
    RequestInvoiceCard,
  },

  computed: {
    ...mapGetters(["getAuthUser", "parentList", "parentPaginationList"]),
  },

  data() {
    return {
      in_view: "ParentDefaultInfo",
      subscribe_form: false,
      parent_list: [],
      pagination_data: {},
      page_index: 0,
      show_empty: false,
    };
  },

  created() {
    this.fetchParents();
  },

  methods: {
    ...mapActions(["getSchoolParents"]),

    // checkParentState() {
    //   if (this.parentList.length > 0) {
    //     this.in_view = "ParentContentInfo";
    //     this.parent_list = this.parentList;
    //     this.pagination_data = this.parentPaginationList;
    //   } else this.fetchParents();
    // },

    fetchParents(page_no = 1) {
      this.getSchoolParents(page_no)
        .then((response) => {
          if (response.code === 200) {
            if (response.data.length > 0) {
              this.in_view = "ParentContentInfo";
              this.parent_list = response.data;
              this.pagination_data = response.pagination;
            } else {
              this.in_view = "ParentDefaultInfo";
              this.show_empty = true;
            }
          } else if (response.code === 204) {
            this.show_empty = true;
            this.in_view = "ParentDefaultInfo";
          }
        })
        .catch((err) => console.log(err));
    },

    loadNewParentList($event) {
      this.getSchoolParents($event)
        .then((response) => {
          this.parent_list = response.data;
          this.pagination_data = response.pagination;
          this.page_index++;
        })
        .catch((err) => console.log(err));
    },

    closeSubscribeForm() {
      this.subscribe_form = !this.subscribe_form;
    },
  },
};
</script>

<style lang="scss">
.school-parent-section {
  // TABLE HEADER
  .table-header {
    line-height: 16px;
    padding-bottom: 6px;
    border-bottom: 1px solid $color_grey_dark;
    margin-bottom: 2px;

    @include breakpoint_max(xl) {
      font-size: 11px;
    }

    @include breakpoint_max(sm) {
      display: none;
    }
  }

  .col-one {
    padding-left: 15px;
    width: 34%;
  }

  .col-two {
    width: 33%;
  }

  .col-three {
    width: 21%;
  }

  .col-four {
    width: 12%;
  }

  @include breakpoint_max(md) {
    .col-one {
      padding-left: 15px;
      width: 38%;
    }

    .col-two {
      width: 28%;
    }

    .col-three {
      width: 22%;
    }

    .col-four {
      width: 12%;
    }
  }

  @include breakpoint_max(sm) {
    .col-one {
      padding-left: 15px;
      width: 80%;
    }

    .col-two {
      width: 0%;
      display: none;
    }

    .col-three {
      width: 0%;
      display: none;
    }

    .col-four {
      width: 20%;
    }
  }

  @include breakpoint_max(xs) {
    .col-one {
      padding-left: 15px;
      width: 85%;
    }

    .col-four {
      width: 15%;
    }
  }
}
</style>
